import { OutPublicUserWithDataWarehouseProductsDTO } from "@app/bf-api";
import { toEan13 } from "@app/util/ean-13";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IAuthState {
  user?: OutPublicUserWithDataWarehouseProductsDTO;
  isLoading?: boolean;
  eanToLike?: string;
  likedEans?: string[];
}

const initialState: IAuthState = {
  isLoading: true,
  likedEans: []
};

export const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<OutPublicUserWithDataWarehouseProductsDTO | undefined>) => {
      state.user = action.payload;
      state.isLoading = false;
    },
    removeLikedDeal: (state, action: PayloadAction<string>) => {
      if (!state.user) {
        return;
      }
      state.likedEans = state.likedEans?.filter((ean) => toEan13(ean) !== toEan13(action.payload));
      state.user = {
        ...state.user,
        dataWarehouseProduct: state.user.dataWarehouseProduct.filter(
          (deal) => toEan13(deal.ean) !== toEan13(action.payload)
        )
      };
    },
    setLikedEans: (state, action: PayloadAction<string[]>) => {
      state.likedEans = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setEanToLike: (state, action: PayloadAction<string | undefined>) => {
      state.eanToLike = action.payload;
    },
    reset: () => initialState
  }
});

export const authReducer = slice.actions;

export default slice.reducer;
